const createForm=require('./form');
module.exports=function(save,navigate){return createForm(async draft=>{const response=await save(draft); draft.Password=''; draft.ConfirmPassword=''; navigate(response.data.redirect);});};
